import { Component } from '@angular/core';
import { BLEManagerService, } from 'src/app/services/ble/ble-manager.service';
import { PreloadLevelType } from 'src/app/services/ble/PreloadLevelType';

@Component({
  selector: 'app-iqconnect-emulator',
  templateUrl: './iq-connect-emulator.component.html',
  styleUrls: ['./iq-connect-emulator.component.scss'],
  standalone: false
})
export class IQConnectEmulatorComponent {
  canTrigger = false;
  canPreload = true;
  canReleasePreload = false;
  forceLevel: number = 1;
  preloadLevel: PreloadLevelType = PreloadLevelType.none;

  constructor(private bleManager: BLEManagerService) {
    this.bleManager.onTriggerState().subscribe(trigger => {
      this.canTrigger = !trigger;
    });

    this.bleManager.onForce().subscribe(force => {
      if (force)
        this.forceLevel = force;
    });

    this.bleManager.onPreload().subscribe(preload => {
      if (preload == PreloadLevelType.green)
        this.canTrigger = true;
      else
        this.canTrigger = false;

      this.preloadLevel = preload;
    });
  }

  triggerIn() {
    this.bleManager.getBleClient().simulateTriggerCommand();
    this.canTrigger = false;
  }

  triggerRelease() {
    this.bleManager.getBleClient().simulateTriggerRelease();
    this.canTrigger = true;
  }

  doubleTrigger() {
    this.bleManager.getBleClient().simulateDoubleTrigger();
  }

  preload(preload: boolean) {
    if (preload) {
      switch (this.preloadLevel) {
        case PreloadLevelType.none:
          this.bleManager.getBleClient().simulatePreload(2);
          break;
        case PreloadLevelType.amber:
          this.bleManager.getBleClient().simulatePreload(2);
          break;
        case PreloadLevelType.green:
          this.bleManager.getBleClient().simulatePreload(2);
          break;
      }
    } else {
      switch (this.preloadLevel) {
        case PreloadLevelType.none:
          this.bleManager.getBleClient().simulatePreload(0);
          break;
        case PreloadLevelType.amber:
          this.bleManager.getBleClient().simulatePreload(0);
          break;
        case PreloadLevelType.green:
          this.bleManager.getBleClient().simulatePreload(1);
          break;
      }
    }
  }

  setLevel(level: number) {
    try {
      this.bleManager.getBleClient().setForce(this.forceLevel + level);

    } catch {
    }
  }
}